import { debug } from "../utils/utils";

/**
 * API Configuration
 *
 * This file contains configuration settings for API endpoints.
 */

import { getEnvConfig } from "./env";

// Determine the base URL based on the environment
export const getApiBaseUrl = (): string => {
    // For production or other environments, use the baseUrl from config
    debug.log(null, "getApiBaseUrl", getEnvConfig().baseUrl);
    return getEnvConfig().baseUrl;
};

// API paths
export const API_PATHS = {
    CASES: "/cases",
    CHATS: (caseId: string) => `/cases/${caseId}/chats`,
    STATUS: (caseId: string) => `/cases/${caseId}/status`,
    MESSAGES: (caseId: string, sessionId: string) => `/cases/${caseId}/${sessionId}/send-message`
};
